import { css } from 'lit';

export default css`.fs-field-label {
  color: var(--fs-form-text-color-label-default, hsl(0, 0%, 8%));
  display: block;
  font-family: var(--fs-font-stack, Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif);
  font-size: var(--fs-font-size-small2, 0.875rem);
  font-weight: var(--fs-font-weight-semibold, 600);
  line-height: var(--fs-font-line-height-normal, 1.5)
}

.fs-field-label.fs-field-label--compact {
    font-size: var(--fs-font-size-small1, 0.75rem);
  }

.fs-field-label.fs-field-label--disabled {
    color: var(--fs-form-text-color-label-disabled, hsl(0, 0%, 49%));
  }

.fs-field-label.fs-field-label--inline {
    display: inline-block;
  }

.fs-field-label.fs-field-label--item {
    font-weight: var(--fs-font-weight-regular, 400);
  }

.fs-field-label.fs-field-label--hidden {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

.fs-field-label.fs-field-label--hidden {
    position: absolute;
      left: -9999px;
  }

.fs-field-label .fs-field-label__optional {
    color: var(--fs-text-color-secondary, hsl(0, 0%, 41%));
    font-weight: var(--fs-font-weight-regular, 400);
  }

.fs-form-field--inline {
  .fs-field-label {
    font-size: var(--fs-font-body-normal, 1rem);
  }
  .fs-field-label--compact {
    font-size: var(--fs-font-body-small, 0.875rem);
  }
}`;